import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/allies/dailyCut/store/paymentHistorySlice/initialState.ts'

const paymentHistorySlice = createSlice({
  name: 'paymentHistory',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    setSelectedAllyId: (state, action: PayloadAction<string>) => {
      state.selectedAllyId = action.payload
    },
    reset: () => initialState
  }
})

export const paymentHistoryActions = paymentHistorySlice.actions
export const { reducer: paymentHistoryReducer } = paymentHistorySlice
